












































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { mapState } from "vuex";
import { Contexts } from "@/models/contexts";
import { IUser } from "@/models/users";
import { IState } from "@/store";

@Component({
  computed: {
    ...mapState({
      user: (state: IState) => state.user
    })
  }
})
export default class ProfileDropdown extends Vue {
  // Getters
  public user!: IUser;

  // Props
  @Prop({ default: Contexts.CLIENT })
  public context!: Contexts;

  public get isAdminContext() {
    return this.context === Contexts.ADMIN;
  }
}
